import { WorkspaceActionsProps } from './WorkspaceActions';
import { Box, Button, Stack, Typography } from '@mui/material';
import { createSearchParams, useSearchParams } from 'react-router-dom';
import { memo } from 'react';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../../../service/store/Store.constants';
import useDeviceStatusFromWorkspace from '../../../../../service/device/CommanderAPI/hooks/useDeviceStatusFromWorkspace';
import { CloudOffIcon, CloudOnIcon } from '../../../../../assets';

export function WorkspaceCommanderStatusAction(props: WorkspaceActionsProps) {
  const { workspace, active } = props;
  const {
    numberFailingMqttConnection,
    isLoading: isLoadingDeviceStatus,
    commanderIdsDevices,
  } = useDeviceStatusFromWorkspace(workspace?.id ?? '', {
    pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
  });

  const [searchBarParams] = useSearchParams();
  const searchParamsObject = Object.fromEntries(searchBarParams.entries());

  const loading = isLoadingDeviceStatus;
  if (!loading && !commanderIdsDevices?.length) return null;

  // Calculate number of stores OK
  const numberStoresOK =
    (commanderIdsDevices?.length ?? 0) - (numberFailingMqttConnection ?? 0);

  // 'storesOk' component
  const storesOk = numberStoresOK ? (
    <Box
      sx={{
        fontSize: '1rem',
        width: '6rem',
        height: '3rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack direction={'row'} spacing={0.5}>
        <Typography
          component="span"
          variant={'inherit'}
          color={!active ? 'success' : 'inherit'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <CloudOnIcon height={'1.5em'} />
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          fontSize={'1rem'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          |
        </Typography>
        <Typography
          component="span"
          variant={'inherit'}
          display={'flex'}
          alignItems={'center'}
          fontSize={'1rem'}
          justifyContent={'center'}
        >
          {numberStoresOK}
        </Typography>
      </Stack>
    </Box>
  ) : null;

  // Show both components if loading or failing
  if (
    loading ||
    (numberFailingMqttConnection && numberFailingMqttConnection > 0)
  ) {
    return (
      <>
        {storesOk}
        <Button
          variant={active ? 'contained' : 'outlined'}
          color={active ? 'primary' : 'inherit'}
          loading={loading}
          href={`/markets/${workspace?.id}/view-locations?${createSearchParams({
            ...searchParamsObject,
            deviceStatusFailing: !active + '',
          }).toString()}`}
          sx={{ fontSize: '1rem', width: '6rem', height: '3rem' }}
        >
          <Stack direction={'row'} spacing={0.5}>
            <Typography
              component="span"
              variant={'inherit'}
              color={!active ? 'error' : 'inherit'}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <CloudOffIcon height={'1.5em'} />
            </Typography>
            <Typography
              component="span"
              variant={'inherit'}
              fontSize={'1rem'}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              |
            </Typography>
            <Typography
              component="span"
              variant={'inherit'}
              display={'flex'}
              alignItems={'center'}
              fontSize={'1rem'}
              justifyContent={'center'}
            >
              {numberFailingMqttConnection ?? 0}
            </Typography>
          </Stack>
        </Button>
      </>
    );
  }

  // Only show storesOk if not loading/failing
  return storesOk;
}

export default memo(WorkspaceCommanderStatusAction);
